import script from "./TemplateView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateView.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateView.vue?vue&type=style&index=0&id=9adcb558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9adcb558"]])

export default __exports__